import * as React from 'react';

function SvgMinus(props) {
  return (
    <svg
      viewBox="0 0 32 32"
      aria-hidden="true"
      style={{
        height: 12,
        width: 12,
      }}
      display="block"
      fill="none"
      stroke="currentcolor"
      strokeWidth={5.333}
      overflow="visible"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M2 16h28" />
    </svg>
  );
}

export default SvgMinus;
